<!-- <button *ngIf="editable && isAddress" (click)="clickBtn()">Address Manage</button> -->
<mat-icon class="icon-general" (click)="clickBtn()" svgIcon="icon-address-placement" matTooltip="Open Address Assignment Wizard"></mat-icon>
